// React
import { FC, useState } from 'react'

// Libraries
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next'

// Custom
import {
  Container,
  TitleContainer,
  GlobeIcon,
  OptionsContainer,
  LanguageOptions,
} from './styled'
import { theme } from 'lib/styled-components/theme'
import useMediaQuery from 'hooks/useMediaQuery'

const LanguageSwitcher: FC = () => {
  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.desktopMin}px)`,
  )
  const { changeLanguage, languages, language } = useI18next()
  const { t } = useTranslation()
  const [showSwitcher, setShowSwitcher] = useState(false)

  const handleLanguage = (item: string) => {
    changeLanguage(item)
  }

  const handleShowSwitcher = () => {
    setShowSwitcher((prev: boolean) => !prev)
  }

  const renderLanguageOptions = () => {
    return languages.map((languageItem, key) => {
      const handleClick = () => {
        handleLanguage(languageItem)
      }

      return (
        <LanguageOptions
          key={key.toString()}
          onClick={handleClick}
          active={languageItem === language}>
          {languageItem.toLocaleUpperCase()}
        </LanguageOptions>
      )
    })
  }

  return (
    <Container>
      <TitleContainer
        onClick={handleShowSwitcher}
        active={showSwitcher}
        data-testid="TitleContainer">
        <GlobeIcon active={showSwitcher} />
        {isDesktop ? language.toLocaleUpperCase() : t('language_label')}
      </TitleContainer>
      <OptionsContainer
        active={showSwitcher}
        onMouseLeave={handleShowSwitcher}
        data-testid="OptionsContainer">
        {renderLanguageOptions()}
      </OptionsContainer>
    </Container>
  )
}

export default LanguageSwitcher
